<div class="absolute top-3 right-3 pointer-events-none z-20">
  <div
    class="bg-red-600 text-white text-xs font-bold py-2 px-4 transform shadow-lg opacity-95 whitespace-nowrap rounded-md"
  >
    LOTE ADJUDICADO
  </div>
</div>
